import TrainsListBaseController from '../../trains-base/controllers/trains-list-base-controller';

export default function TrainsListController(
    $scope,
    $controller,
    trainsFactory
) {
    'ngInject';

    $controller(TrainsListBaseController, {
        $scope,
        trainsFactory,
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/train/controllers/trains-list-controller.js